import mapboxgl from 'mapbox-gl';
import json from '../../data/VE_gold_data.json';
import { createLayers } from './create-layers';

const mapData = json['VE_gold_data'];

export default class ScrollerMap {
  constructor() {
    this.container = document.getElementById('map');
    this.requestID; // controls animation
    this.isMobile = window.innerWidth <= 768;

    mapboxgl.accessToken =
      'pk.eyJ1IjoiYWFsYnJpZ2h0LW1oIiwiYSI6ImNqM3ExYTFrbzAwdWoyd3BmOXBsdWlraWoifQ.4ZSAZpc41c39EWcwFhUjoA';

    this.map = new mapboxgl.Map({
      container: this.container,
      style: 'mapbox://styles/aalbright-mh/cjxkl2qys01vd1cqe1981y536',
      zoom: this.isMobile ? 2.5 : 3.5,
      center: [-63.69144324873017, 10.910756756213402],
      // scrollZoom: false
      interactive: false
    });

    this.setHeight();

    this.map.on('load', () => {
      createLayers(this.map);
    });
  }
  resize() {
    this.setHeight();
    this.map.resize();
  }
  setHeight() {
    let h = this.isMobile ? window.innerHeight * 0.95 : window.innerHeight;
    this.container.style.height = `${h}px`;
  }
  animateTo(stepID) {
    const map = this.map;
    const step = mapData.find(d => d.id === stepID);
    const layers = map.getStyle().layers.filter(l => l.id.includes('step'));

    let prevDelta = 0;
    let fpsLimit = 20;
    let stp = 0;
    let dashArraySeq = [
      [0, 4, 3],
      [1, 4, 2],
      [2, 4, 1],
      [3, 4, 0],
      [0, 1, 3, 3],
      [0, 2, 3, 2],
      [0, 3, 3, 1]
    ];

    const animateLine = currentDelta => {
      this.requestID = requestAnimationFrame(animateLine);

      let delta = currentDelta - prevDelta;
      if (delta < 1000 / fpsLimit) {
        return;
      }
      stp = (stp + 1) % dashArraySeq.length;
      map.setPaintProperty(stepID, 'line-dasharray', dashArraySeq[stp]);
      prevDelta = currentDelta;
    };

    if (step.zoom) {
      map.easeTo({
        zoom: this.isMobile ? step.zoom - 0.5 : step.zoom,
        center: { lon: step.lng, lat: step.lat } || ''
      });
    }

    layers.forEach(l => {
      map.setPaintProperty(
        l.id,
        `${l.type == 'symbol' ? 'text' : l.type}-opacity`,
        0
      );
    });

    if (map.getLayer(stepID)) {
      map.setPaintProperty(stepID, `${step.type}-opacity`, 0.6);

      if (step.type === 'line') {
        window.cancelAnimationFrame(this.requestID);
        requestAnimationFrame(animateLine);
      }

      if (map.getLayer(`${stepID}-cir`)) {
        map.setPaintProperty(`${stepID}-cir`, `circle-opacity`, 1);
        map.setPaintProperty(`${stepID}-sym`, `text-opacity`, 1);
      }
    }
  }
}
